<script>
import accesslevels from '@utils/accesslevels'
import { voaReportMethods } from '@state/helpers'
import constant from '@constants/constant'

export default {
  props: {
    customerId: {
      type: [Number, String],
      default: '',
    },
    customerUserId: {
      type: [Number, String],
      default: '',
    },
    productId: {
      type: [Number, String],
      default: '',
    },
    productAddOns: {
      type: Array,
      default: Array,
    },
    orderData: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      messageType: '',
      alertMessage: '',
      showSpinner: false,
      referenceNumber: '',
      borrowerFirstName: '',
      borrowerLastName: '',
      borrowerSSN: '',
      employerName: '',
      email: '',
      PhoneNumber: '',
      showmessage: false,
      orderId: '',
      accountHistory: '',
      refreshPeriod: '',
      autherror: '',
      refreshPeriodTypes: [],
      accountHistoryTypes: [
        { text: '30 days', value: '30' },
        { text: '60 days', value: '60' },
        { text: '90 days', value: '90' },
        { text: '183 days', value: '183' },
        { text: '365 days', value: '365' },
        { text: '731 days', value: '731' },
      ],
    }
  },
  computed: {
    placeholders() {
      return {
        firstName: 'First Name',
        lastName: 'Last Name',
        ssn: 'xxx-xx-xxxx',
        referenceNumber: 'Reference Number',
        email: 'Email ID',
        phoneNumber: '(xxx) xxx-xxxx',
        employerName: 'Employer Name',
      }
    },
    isCustRequestor() {
      return accesslevels(9)
    },
    getRefreshPeriod() {
      switch (this.refreshPeriod) {
        case 'One Time Report':
          return 1
        case '30 Days Refresh':
          return 30
        case '60 Days Refresh':
          return 60
        case '90 Days Refresh':
          return 90
        default:
          return 1
      }
    },
  },
  mounted() {
    for (var i = 0; i < this.productAddOns.length; i++) {
      if (this.productAddOns[i].changeable === true) {
        this.refreshPeriodTypes.push({
          text: this.productAddOns[i].name,
          value: this.productAddOns[i].name,
        })
      }
    }
  },

  methods: {
    ...voaReportMethods,
    async getModal(message, type, method) {
      await this.$refs.msg.showAsync(message, type, 'Ok').then(() => {
        if (method) {
          method()
        }
      })
    },
    buildVoaRequest() {
      let userInfo = this.$store.state.auth.currentUser.userInfo
      let custUserId
      if (this.isCustRequestor) {
        custUserId = userInfo.userId
      } else {
        custUserId = this.customerUserId
      }
      let VoaRequestObj = {
        userId: userInfo.userId,
        productId: this.productId,
        OrderForUser: custUserId,
        OrderForCustomer: this.customerId,
        borrowerFirstName: this.borrowerFirstName,
        borrowerLastName: this.borrowerLastName,
        borrowerSSN: this.borrowerSSN,
        referenceNo: this.referenceNumber,
        borrowerEmailId: this.email,
        employerName: this.employerName === '' ? null : this.employerName,
        accountHistory: this.accountHistory,
        refreshPeriod: this.getRefreshPeriod,
        phoneNumber: this.PhoneNumber?this.PhoneNumber.replace(/[^0-9]/g, ''):'',
      }

      return VoaRequestObj
    },
    onVoaReportSubmit() {
      var isOrderReportComponentValid = false
      var isVoEReportComponentValid = false
      var that = this
      this.$parent.$parent.$validator.validateAll().then((response) => {
        isOrderReportComponentValid = response
        this.$validator.validate().then((response) => {
          if (this.isCustRequestor) {
            isOrderReportComponentValid = response
          }
          isVoEReportComponentValid = response
          if (isOrderReportComponentValid && isVoEReportComponentValid) {
            this.showSpinner = true
            that
              .generateVoAreports(that.buildVoaRequest())
              .then((response) => {
                if (response && response.data.ResponseStatus === 0) {
                  this.getModal(
                    response.data.Message,
                    constant.imageHeaderError
                  )
                } else {
                  let respData = response.data || response
                  if (respData.orderId !== undefined) {
                    this.$router.push({
                      name: 'voaResults',
                      params: {
                        orderId: respData.orderId,
                        callOrigin: constant.origin.OrderReport,
                        productId: this.productId,
                      },
                    })
                  }
                }

                this.showSpinner = false
              })
              .catch((error) => {
                this.showSpinner = false
                this.autherror = error
                this.getModal(constant.errorMessage, constant.imageHeaderError)
              })
          }
        })
      })
    },
  },
}
</script>
<template>
  <section>
    <BaseModalLayout ref="msg" hide-cancel modal-size="md" />
    <BaseSpinner v-if="showSpinner" />
    <b-form @submit.prevent="onVoaReportSubmit">
      <b-row class="pb-3">
        <b-col md="3">
          <BaseEInputText
            id="referenceNumber"
            v-model="referenceNumber"
            v-validate="{ required: true, regex: /^[A-Za-z0-9 ]+$/ }"
            validattor="^[A-Za-z0-9]+$"
            type="text"
            name="referenceNumber"
            maxlength="50"
            label-content="Reference Number"
            data-vv-as="Reference No."
            mark-required
            :placeholder="placeholders.referenceNumber"
          />
          <div class="error">
            {{ errors.first('referenceNumber') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseELabel mark-required label="Account History" />
          <BaseDropdown
            v-model="accountHistory"
            v-validate="'required'"
            :field-id="accountHistory"
            :options="accountHistoryTypes"
            data-vv-as="Account History"
            name="accountHistory"
          ></BaseDropdown>
          <div class="error">
            {{ errors.first('accountHistory') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseELabel mark-required label="Refresh Period" />
          <BaseDropdown
            v-model="refreshPeriod"
            v-validate="'required'"
            :field-id="refreshPeriod"
            :options="refreshPeriodTypes"
            data-vv-as="Refresh period"
            name="refreshPeriod"
          ></BaseDropdown>
          <div class="error">
            {{ errors.first('refreshPeriod') }}
          </div>
        </b-col>
      </b-row>
      <b-row class="pb-3">
        <b-col md="3">
          <BaseEInputText
            id="borrowerFirstName"
            v-model="borrowerFirstName"
            v-validate="{ required: true, regex: /^[A-Za-z0-9 ]+$/ }"
            validattor="^[A-Za-z0-9]+$"
            type="text"
            name="borrowerFirstName"
            maxlength="50"
            label-content="First Name"
            data-vv-as="First Name"
            mark-required
            :placeholder="placeholders.firstName"
          />
          <div class="error">
            {{ errors.first('borrowerFirstName') }}
          </div>
        </b-col>

        <b-col md="3">
          <BaseEInputText
            id="borrowerLastName"
            v-model="borrowerLastName"
            v-validate="{ required: true, regex: /^[A-Za-z0-9 ]+$/ }"
            validattor="^[A-Za-z0-9]+$"
            type="text"
            name="borrowerLastName"
            maxlength="50"
            label-content="Last Name"
            data-vv-as="Last Name"
            mark-required
            :placeholder="placeholders.lastName"
          />
          <div class="error">
            {{ errors.first('borrowerLastName') }}
          </div>
        </b-col>

        <b-col md="3">
          <BaseEInputText
            id="borrowerSSN"
            v-model="borrowerSSN"
            v-validate="{ required: true, regex: /^\d{3}-?\d{2}-?\d{4}$/ }"
            validattor="[0-9]"
            maskker="(\d{3})(\d{2})(\d{4})"
            formatter="$1-$2-$3"
            type="text"
            maxlength="11"
            name="borrowerSSN"
            label-content="SSN"
            data-vv-as="SSN"
            mark-required
            :placeholder="placeholders.ssn"
          />
          <div class="error">
            {{ errors.first('borrowerSSN') }}
          </div>
        </b-col>
      </b-row>
      <b-row class="pb-3">
        <b-col md="3">
          <BaseEInputText
            id="borrower-email"
            v-model="email"
            v-validate="{
              required: true,
              regex: /\S+@\S+\.\S+/,
            }"
            type="text"
            maxlength="100"
            name="email"
            label-content="Email ID"
            data-vv-as="Email ID"
            mark-required
            :placeholder="placeholders.email"
          />
          <div class="error">
            {{ errors.first('email') }}
          </div>
        </b-col>

        <b-col md="3">
          <BaseEInputText
            id="PhoneNumber"
            v-model="PhoneNumber"
            v-validate="{
              regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
            }"
            validattor="[0-9]"
            maskker="(\d{3})(\d{3})(\d{4})"
            formatter="($1) $2-$3"
            type="text"
            maxlength="14"
            name="PhoneNumber"
            label-content="Phone number#"
            data-vv-as="Phone number#"
            :placeholder="placeholders.phoneNumber"
          />
          <div class="error">
            {{ errors.first('PhoneNumber') }}
          </div>
        </b-col>
      </b-row>

      <b-row class="pb-3  border-bottom">
        <b-col md="3">
          <BaseEInputText
            id="employerName"
            v-model="employerName"
            v-validate="{ required: false, regex: /^[A-Za-z0-9 ]+$/ }"
            validattor="^[A-Za-z0-9 ]+$"
            type="text"
            name="employerName"
            maxlength="50"
            label-content="Employer Name"
            data-vv-as="Employer Name"
            :placeholder="placeholders.employerName"
          />
          <div class="error">
            {{ errors.first('employerName') }}
          </div>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col>
          <BaseEButton type="submit" name="order">
            Order
          </BaseEButton>
        </b-col>
      </b-row>
    </b-form>
  </section>
</template>
